import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

// Shows time remaining until a provider's completion request auto-confirms
// (and funds auto-release) if the client doesn't respond. The window (hours) is
// configurable by the platform owner; defaults to 24h.
const AutoReleaseCountdown = ({ requestedAt, variant = 'client', hours = 24 }) => {
  const windowHours = Number(hours) > 0 ? Number(hours) : 24;
  const deadline = requestedAt ? new Date(requestedAt).getTime() + windowHours * 3600 * 1000 : null;
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!deadline) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [deadline]);

  if (!deadline) return null;

  const remaining = deadline - now;
  const passed = remaining <= 0;
  const h = Math.max(0, Math.floor(remaining / 3600000));
  const m = Math.max(0, Math.floor((remaining % 3600000) / 60000));
  const s = Math.max(0, Math.floor((remaining % 60000) / 1000));
  const timeStr = `${String(h).padStart(2, '0')}h ${String(m).padStart(2, '0')}m ${String(s).padStart(2, '0')}s`;

  const label = variant === 'provider'
    ? (passed ? 'Auto-releasing your payment…' : 'Payment auto-releases to you in')
    : (passed ? 'Auto-confirming completion…' : 'Auto-confirms & releases funds in');

  return (
    <div
      className={`flex items-center gap-2 rounded-lg px-3 py-2 text-sm ${passed ? 'bg-emerald-50 text-emerald-700 border border-emerald-200' : 'bg-amber-50 text-amber-800 border border-amber-200'}`}
      data-testid="auto-release-countdown"
    >
      <Clock className="w-4 h-4 shrink-0" />
      <span>
        {label}{' '}
        {!passed && <strong className="tabular-nums" data-testid="auto-release-timer">{timeStr}</strong>}
      </span>
    </div>
  );
};

export default AutoReleaseCountdown;
